module.exports = __webpack_public_path__ + "images/SMM.5de483d25c1a7307afefbc2ebf188567.png";